/**
 * Queries
 */
export const COURSES_LIST_QUERY = {
  order: '-first_published_at',
  fields: [
    'summary',
    'metadata',
    'crehana_course_id',
    'crehana_course_url',
    'header_image_list_standar',
    'course_authors(author(*,picture(*)))',
    'course_categories(category(name))',
    'preview_video(*)',
    'preview_embed',
    'subscriptions',
    'likes',
    'provider',
    'lachiripa_course_url',
    'lachiripa_type',
    'has_specialization'
  ].join(',')
}

export const COURSE_CATEGORY = {
  order: '-first_published_at',
  fields: [
    'course_categories(category(name))'
  ].join(',')
}

export const COURSES_DETAIL_QUERY = {
  fields: [
    '*',
    'preview_video(*)',
    'course_authors(author(*,picture(*)))',
    'course_categories(category(name))'
  ].join(',')
}

export const COURSES_CATEGORIES_LIST_QUERY = {
  order: '-categorized_resources',
  fields: [
    '*'
  ].join(',')
}

export const RESOURCES_LIST_QUERY = {
  order: '-first_published_at',
  fields: [
    'title',
    'summary',
    'kind',
    'document(*)',
    'multimedia(*)',
    'header_image_list_standar',
    'resource_authors(author(*,picture(*)))',
    'resource_categories(category(name,id))',
    'downloads',
    'likes'
  ].join(',')
}

export const RESOURCES_DOCUMENT_LIST_QUERY = {
  order: '-first_published_at',
  kind: 'document',
  fields: [
    'title',
    'summary',
    'kind',
    'document(*)',
    'header_image_list_standar',
    'resource_authors(author(*,picture(*)))',
    'resource_categories(category(name,id))',
    'downloads',
    'likes'
  ].join(',')
}

export const RESOURCES_LIST_QUERY_CUSTOM = (customQuery) => ({
  order: '-first_published_at',
  fields: [
    'title',
    'summary',
    'kind',
    'document(*)',
    'multimedia(*)',
    'header_image_list_standar',
    'resource_authors(author(*,picture(*)))',
    'resource_categories(category(name,id))',
    'downloads',
    'likes'
  ].join(','),
  ...customQuery
})

export const RESOURCES_VIDEO_LIST_QUERY = {
  order: '-first_published_at',
  kind: 'video',
  fields: [
    'title',
    'summary',
    'kind',
    'document(*)',
    'header_image_list_standar',
    'resource_authors(author(*,picture(*)))',
    'resource_categories(category(name,id))',
    'downloads',
    'likes'
  ].join(',')
}
export const RESOURCES_AUDIO_LIST_QUERY = {
  order: '-first_published_at',
  kind: 'audio',
  fields: [
    'title',
    'summary',
    'kind',
    'document(*)',
    'header_image_list_standar',
    'resource_authors(author(*,picture(*)))',
    'resource_categories(category(name,id))',
    'downloads',
    'likes'
  ].join(',')
}
export const RESOURCES_EBOOKS_LIST_QUERY = {
  order: '-first_published_at',
  kind: 'ebook',
  fields: [
    'title',
    'summary',
    'kind',
    'document(*)',
    'header_image_list_standar',
    'resource_authors(author(*,picture(*)))',
    'resource_categories(category(name,id))',
    'downloads',
    'likes'
  ].join(',')
}

export const RESOURCES_DETAIL_QUERY = {
  fields: [
    'resource_authors(author(*,picture(*)))',
    'resource_categories(category(name))',
    `related_resource_from(resource_to(${RESOURCES_LIST_QUERY.fields}))`,
    'document(*)',
    'multimedia(*)'
  ].join(',')
}

export const RESOURCES_CATEGORIES_LIST_QUERY = {
  order: '-categorized_resources',
  fields: [
    '*'
  ].join(',')
}

export const TRANSMISSIONS_LIST_QUERY = {
  order: 'begin_time',
  fields: [
    'title',
    'summary',
    'live_url',
    'begin_time',
    'end_time',
    'header_image_list_standar',
    'transmission_authors(author(*,picture(*)))',
    'transmission_categories(category(name))',
    'likes',
    'views',
    'transmission_state',
    'registration_form(*)',
    'registration_title'
  ].join()
}

export const TESTIMONIALS_LIST_QUERY = {
  fields: [
    '*'
  ].join(',')
}

export const TRANSMISSIONS_DETAIL_QUERY = {
  fields: [
    'transmission_authors(author(*,picture(*)))',
    'transmission_categories(category(name))',
    'recorded_video(title,file,thumbnail)'
  ].join()
}

export const NEWS_LIST_QUERY = {
  order: '-first_published_at',
  fields: [
    'title',
    'excerpt',
    'reading_time',
    'header_image(*)',
    'header_image_list_square',
    'header_image_list_standar',
    'news_authors(author(*,picture(*)))',
    'news_categories(category(name))',
    'likes'
  ].join()
}

export const NEWS_LIST_QUERY_CUSTOM = (customparams) => ({
  order: '-first_published_at',
  fields: [
    'title',
    'excerpt',
    'reading_time',
    'header_image(*)',
    'header_image_list_square',
    'header_image_list_standar',
    'news_authors(author(*,picture(*)))',
    'news_categories(category(name))',
    'likes'
  ].join(),
  ...customparams
})

export const NEWS_INDEX_QUERY = {
  fields: [
    '*',
    `secondary_featured_news(news(${NEWS_LIST_QUERY.fields}))`,
    `featured_news(${NEWS_LIST_QUERY.fields})`
  ].join()
}

export const NEWS_DETAIL_QUERY = {
  fields: [
    'header_image(*)',
    'news_authors(author(*,picture(*)))',
    'news_categories(category(name))',
    `related_news_from(news_to(${NEWS_LIST_QUERY.fields}))`
  ].join()
}

export const NEWS_CATEGORIES_LIST_QUERY = {
  order: '-categorized_news',
  fields: [
    '*'
  ].join(',')
}

export const RESOURCE_CATEGORIES_LIST_QUERY = {
  order: '-categorized_resources',
  fields: [
    '*'
  ].join(',')
}

export const COURSE_CATEGORIES_LIST_QUERY = {
  order: '-categorized_courses',
  fields: [
    '*'
  ].join(',')
}

export const TRANSMISSION_CATEGORIES_LIST_QUERY = {
  order: '-categorized_transmissions',
  fields: [
    '*'
  ].join(',')
}

export const SEARCH_QUERY = {
  order: '-first_published_at',
  fields: [
    '*'
  ].join(',')
}

export const COMMENT_LIST_QUERY = {
  order: '-created',
  fields: [
    '*',
    'author(full_name,wagtail_userprofile(avatar))'
  ].join(',')
}
